import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { provideBaseClass, useModifierGroup } from '@bynary/composables/class';

import { CardAppearance, CardAppearanceType } from './models/card-appearance.enum';

/**
 * Card component for displaying content in a card
 */
@Component({
    selector: 'sona-card',
    imports: [],
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [provideBaseClass('c-sona-card')],
    host: {
        class: 'card'
    }
})
export class SonaCardComponent {
    private _appearance = useModifierGroup<CardAppearanceType>(
        CardAppearance.RAISED
    );

    /**
     * The appearance of the card
     */
    @Input()
    get appearance(): CardAppearanceType {
        return this._appearance();
    }

    set appearance(value: CardAppearanceType) {
        this._appearance.set(value);
    }
}
